import React, {
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { isArray, isEmpty, isUndefined, isNumber } from 'lodash';
import { parse, format } from 'date-fns';

import { Tabs } from '~/components';
import { t } from '~/helpers';
import {
  changeDaysWeek,
  changeBlockDates,
  changeCounties,
  changeQuotas,
  resetValues,
  changeCountiesProduts,
} from '~/store/modules/vehicleRegistration/actions';
import api from '~/services/api';

import ComponentDados from '../components/Dados';
import ComponentParametros from '../components/Parametros';
import ComponentCotas from '../components/Cota';

export default function FormVehicle({
  data,
  diasLiberacao,
  datasBloqueio,
  municipios,
  municipioprodutos,
  cotas,
  sending,
  close,
}) {
  const tabRef = useRef(null);
  const dispatch = useDispatch();

  const [initials, setInitials] = useState(data);

  const { daysWeek, blockDates, counties, quotas, countiesProduts } = useSelector(
    (state) => state.vehicleRegistration
  );

  const { find } = useSelector((state) => state.veiculo);
  const userInfo = useSelector((state) => state.user);
  const { gloperfilid } = userInfo.profile



  const dataValidation = useMemo(
    () => ({
      veic_bloqueio_inadimplencia: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
      veic_possui_transp: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
      veic_possui_dvec: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
      veic_limite_sem_dvec: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
      veic_bloqueado: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
    }),
    []
  );

  const parametersValidation = useMemo(
    () => ({
      veic_transacoes: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('veic_tipo_transacao', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, 'O valor da Transação deve ser maior que 0'),
        }),
      veic_intervalo: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('veic_tipo_intervalo', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .min(1, 'O valor do Intervalo deve ser maior que 0')
            .required(t('s.geral.validacao.campoobrigatorio')),
        }),
    }),
    []
  );

  const tabs = useMemo(
    () => {
      return [
        {
          label: 'Dados',
          component: ComponentDados,
          validate: dataValidation,
        },
        {
          label: 'Parâmetros',
          component: (props) => <ComponentParametros dataVeic={data} {...props} />,
          validate: parametersValidation,
        },
        {
          label: 'Cota',
          component: () => (
            <ComponentCotas board={data ? data.veic_placa_aux : 0} />
          ),
        },
      ]


    },
    [dataValidation, parametersValidation, data]
  );

  const handleSubmit = useCallback(async (value) => {
    try {
      // Validação  - ABASTECER SOMENTE NOS DIAS DA SEMANA
      // console.log('9989 - handleSubmit' + JSON.stringify(value))

      let daysWeekErrs = [];
      value.params.daysWeek.forEach((date) => {
        if (date.error) {
          let dayOfWeek = '';
          switch (date.day) {
            case 1:
              dayOfWeek = 'Domingo';
              break;
            case 2:
              dayOfWeek = 'Segunda';
              break;
            case 3:
              dayOfWeek = 'Terça';
              break;
            case 4:
              dayOfWeek = 'Quarta';
              break;
            case 5:
              dayOfWeek = 'Quinta';
              break;
            case 6:
              dayOfWeek = 'Sexta';
              break;
            case 7:
              dayOfWeek = 'Sábado';
              break;
          }
          daysWeekErrs.push(`(ABASTECER SOMENTE NOS DIAS DA SEMANA)
          ${dayOfWeek} - Erro: Data Inválida !
        `);
        }
      });

      if (!isEmpty(daysWeekErrs)) {
        throw daysWeekErrs;
      }

      let formData = {
        veiculo: {
          ...value.fields,
          veic_bloqueio_inadimplencia_observacao:
            value.fields.veic_bloqueio_inadimplencia === 'N'
              ? ''
              : value.fields.veic_bloqueio_inadimplencia_observacao,
        },
        datasBloqueio: value.params.blockDates.map((block) => ({
          veic_placa: value.fields.veic_placa,
          vdbl_data: `${block.date} 00:00:00`,
          usua_login_rep_veiculo_db_band: block.perfil_cad
        })),
        diasLiberacao: value.params.daysWeek.map((day) => ({
          veic_placa: value.fields.veic_placa,
          vdli_dia: day.day,
          vdli_hora_fim: format(
            parse(day.final, 'HH:mm', new Date()),
            'dd/MM/yyyy HH:mm:ss'
          ),
          vdli_hora_ini: format(
            parse(day.initial, 'HH:mm', new Date()),
            'dd/MM/yyyy HH:mm:ss'
          ),
          usua_login_rep_veiculo_dl_asndds: day.perfil_cad,
        })),
        municipios: value.params.counties.map((county) => ({
          veic_placa: value.fields.veic_placa,
          muni_codigo: county.muni_codigo,
          muni_nome: county.muni_nome,
          usua_login_rep_veiculo_m_mlpa: county.perfil_cad,
        })),
        cotas: value.params.quotas.map((quota) => ({
          veic_placa: value.fields.veic_placa,
          prod_codigo: quota.prod_codigo,
          prod_descricao: quota.prod_descricao,
          cove_cota: quota.cove_cota,
          cove_saldo: isNumber(quota.cove_saldo) ? quota.cove_saldo : String(quota.novo_cove_saldo),
          cove_justificativa: quota.cove_justificativa,
          usua_login_rep_cota_veic: quota.perfil_cad
        })),
        municipioprodutos: value.params.countiesProduts.map((countiesprodut) => ({
          veic_placa: value.fields.veic_placa,
          muni_codigo: countiesprodut.muni_codigo,
          muni_nome: countiesprodut.muni_nome,
          prod_codigo: countiesprodut.prod_codigo,
          prod_descricao: countiesprodut.prod_descricao,
          usua_login_rep_veiculo_m_mlpa: countiesprodut.perfil_cad,
        })),
      };


      if (value.fields.veic_tipo_transacao != data.veic_tipo_transacao || value.fields.veic_transacoes != data.veic_transacoes) {
        formData.veiculo = { ...formData.veiculo, usua_login_rep_veiculo_lapt: userInfo.profile.glousuariologin }
      }

      if (value.fields.veic_tipo_intervalo != data.veic_tipo_intervalo || value.fields.veic_intervalo != data.veic_intervalo) {
        formData.veiculo = { ...formData.veiculo, usua_login_rep_veiculo_lapi: userInfo.profile.glousuariologin }
      }

      if (value.fields.veic_tipo_transacao == 0) {
        formData.veiculo = { ...formData.veiculo, veic_transacoes: 0 }
      }
      if (value.fields.veic_tipo_intervalo == 0) {
        formData.veiculo = { ...formData.veiculo, veic_intervalo: 0 }
      }


      await api.put('veiculo', formData);

      toast.success('Veículo atualizado com sucesso!');

      dispatch(resetValues());
      setInitials({});
      close();
    } catch (err) {

      console.log(JSON.stringify(err))

      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [userInfo, data]);

  useEffect(() => {
    if (sending) tabRef.current.onValidate();
  }, [sending]);

  useEffect(() => {
    if (!isEmpty(diasLiberacao))
      dispatch(
        changeDaysWeek(
          diasLiberacao.map((day) => ({
            day: day.vdli_dia,
            error: false,
            final: format(
              parse(day.vdli_hora_fim, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'HH:mm'
            ),
            initial: format(
              parse(day.vdli_hora_ini, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'HH:mm'
            ),
            perfil_cad: day.usua_login_rep_veiculo_dl_asndds,
            perfil_tipo: day.usua_login_rep_veiculo_dl_asndds_perf_tipo,
            perfil_desc: day.usua_login_rep_veiculo_dl_asndds_perf_descricao,
          }))
        )
      );
  }, [diasLiberacao]);

  useEffect(() => {
    if (!isEmpty(datasBloqueio))
      dispatch(
        changeBlockDates(
          datasBloqueio.map((block) => ({
            date: format(
              parse(block.vdbl_data, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'dd/MM/yyyy'
            ),
            perfil_cad: block.usua_login_rep_veiculo_db_band,
            perfil_tipo: block.usua_login_rep_veiculo_db_band_perf_tipo,
            perfil_desc: block.usua_login_rep_veiculo_db_band_perf_descricao,
          }))
        )
      );
  }, [datasBloqueio]);

  useEffect(() => {
    if (!isEmpty(municipios))
      dispatch(
        changeCounties(
          municipios.map((muni) => ({
            ...muni,
            perfil_cad: muni.usua_login_rep_veiculo_m_mlpa,
            perfil_tipo: muni.usua_login_rep_veiculo_m_mlpa_perf_tipo,
            perfil_desc: muni.usua_login_rep_veiculo_m_mlpa_perf_descricao,
          }))
        )
      );
  }, [municipios]);


  useEffect(() => {
    if (!isEmpty(municipioprodutos))
      dispatch(
        changeCountiesProduts(
          municipioprodutos.map((muni) => ({
            ...muni,
            perfil_cad: muni.usua_login_rep_veiculo_m_mlpa,
            perfil_tipo: muni.usua_login_rep_veiculo_m_mlpa_perf_tipo,
            perfil_desc: muni.usua_login_rep_veiculo_m_mlpa_perf_descricao,
          }))
        )
      );
  }, [municipioprodutos]);

  useEffect(() => {
    if (!isEmpty(cotas)) {
      dispatch(
        changeQuotas(
          cotas.map((cota) => ({
            ...cota,
            perfil_cad: cota.usua_login_rep_cota_veic,
            perfil_tipo: cota.usua_login_rep_cota_veic_perf_codigo,
            perfil_desc: cota.usua_login_rep_cota_veic_perf_descricao,
          })
          )
        ))
    }

  }, [cotas]);

  useEffect(() => {
    setInitials(isUndefined(data) ? {} : data);
  }, [data]);

  if (isEmpty(initials)) return 'Carregando...';

  return (
    <Tabs
      ref={tabRef}
      color="default"
      indicatorColor="primary"
      textColor="primary"
      initials={{
        veic_tipo_transacao: 0,
        veic_transacoes: 0,
        veic_tipo_intervalo: 0,
        veic_intervalo: 0,
        ...initials,
      }}
      tabs={tabs}
      getData={handleSubmit}
      params={{ daysWeek, blockDates, counties, quotas, countiesProduts }}
    />
  );
}

FormVehicle.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  diasLiberacao: PropTypes.arrayOf(PropTypes.any).isRequired,
  datasBloqueio: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipios: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipioprodutos: PropTypes.arrayOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
